import React from "react";
import "./notFoundPage.css";

const NotFoundPage = () => {
	return (
		<div className="not-found-page">
			<h1>404 not found</h1>
		</div>
	);
};

export default NotFoundPage;
